import React,{useState,useEffect,useCallback} from 'react';

///Styles
import { toast } from 'react-toastify';
import {ContainerLoading,Container,Content,Table,Button} from './styles';
import {formatMoney} from '../../../../Utils/formatMoney';

///Components
import { SpaceLoader } from '../../../loaders/spaceLoader';
import { ButtonExportExcel } from '../buttonExportExcel';

///Services
import {api} from '../../../../services/api';
import { useAdministrativeContext } from '../../../../pages/administrativePanel/administrativePanelContext';
import moment from 'moment';
import { download_csv } from '../centralizedModal/JsonToCsv';



export function MonthlyBilling(){
    const {
        startDate,
        endDate,
        listBusinessToFilter,
        listSalesChannelsId
    } = useAdministrativeContext();

    const [companies,setCompanies] = useState([]);
    const [page,setPage] = useState(1);
    const [loading,setLoading] = useState(true);
    const [loadingButton,setLoadingButton] = useState(false);
    const [open,setOpen] = useState(false);

    useEffect(() => {
        async function loadData(){
            setLoading(true)
            try{
                const response = await api.post('/getResumeMonthlyBilling?page=1',{
                    rankingDatas: {
                        business: listBusinessToFilter,
                        salesChannels: listSalesChannelsId,
                        endDate: endDate,
                        startDate: startDate,
                    },
                })

                const {data,next_page} = response.data;
                //console.log(response.data)

                setCompanies(data);
                setPage(next_page);
                setLoading(false);
            }
            catch(error){
                toast.error('Ops, algo deu errado !!');
                setLoading(false);
            }
        }
        loadData();
    },[endDate,listBusinessToFilter,listSalesChannelsId,startDate]);

    const handleNewData = useCallback(async () => {
        setLoadingButton(true);
        try{
            const response = await api.post(`/getResumeMonthlyBilling?page=${page}`,{
                rankingDatas: {
                    business: listBusinessToFilter,
                    salesChannels: listSalesChannelsId,
                    endDate: endDate,
                    startDate: startDate,
                },
            })

            const {data,next_page} = response.data;
            //console.log(response.data)

            setCompanies([...companies,...data]);
            setPage(next_page);
            setLoadingButton(false);
        }
        catch(error){
            toast.error('Ops, algo deu errado !!');
            setLoadingButton(false);
        }
    },[companies,endDate,listBusinessToFilter,listSalesChannelsId,page,startDate]);

    async function handleDownloadCSV(){
        setLoading(true);
        try{
            const response = await api.post('/getResumeMonthlyBilling?page=0',{
                rankingDatas: {
                    business: listBusinessToFilter,
                    salesChannels: listSalesChannelsId,
                    endDate: endDate,
                    startDate: startDate,
                },
            })

            const {data} = response.data;
            
            let newArr = data.map((item) => {
                let arr = Object.entries(item).slice(9).map((item) => {
                    return item
                })
                .reduce((value,next,index) => {
                    value[moment(next[0]).format('MM/YYYY')] = Number(next[1]).toFixed(2)
                    return value
                },{})
                
                //console.log(arr)
    
                return{
                    id: item.cdEmpresa,
                    id_Customizado: item.idCustomized,
                    CNPJ: item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
                    Empresa: item.dsEmpresa,
                    Municipio: item.dsMunicipio,
                    Estado: item.dsUf,
                    Data_Inauguracao: moment(item.dtInauguracao).utcOffset(0).format('DD/MM/YYYY HH:mm:ss') === 'Invalid date' ? '' : moment(item.dtInauguracao).utcOffset(0).format('DD/MM/YYYY HH:mm:ss'),
                    ...arr,
                    Valor_Acumulado: Number(Object.entries(item).slice(8).map((value) => {
                        return value[1]
                    })
                    .reduce((value,next) => {
                        return value + next
                    })).toFixed(2),
                    Ticket_Medio: Number(item.ticketMedio).toFixed(2),
                }
            })
    
            //console.log(newArr)
            download_csv(newArr,'Faturamento mensal');
            setLoading(false);
            setOpen(false)

        }
        catch(error){
            toast.error('Ops, algo deu errado !!');
            setLoading(false);
        }
    }


    if(loading){
        return (
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return(
        <Container>
            <ButtonExportExcel
                open={open}
                setOpen={setOpen}
                handleDownloadCSV={handleDownloadCSV}
            />
            <Content>
                <Table>
                        <thead>
                            <tr>                                    
                                <th>ID</th>
                                <th>ID Customized</th>
                                <th className='header-fixed'>Empresa</th>

                                {
                                    companies !== undefined && Object.entries(companies[0]).slice(9).map((value,index) => {
                                        return <th key={index}>{moment(value[0]).format('MM/YYYY')}</th>
                                    })
                                }

                                <th>Valor Acumulado</th>
                                <th>Ticket Médio</th>
                            </tr>
                        </thead>

                        <tbody>
                            {companies?.map((item,index) => {
                                return(
                                    <tr key={item.cdEmpresa}>
                                        <td>{item.cdEmpresa}</td>
                                        <td>{item.idCustomized}</td>
                                        <td className='body-fixed'>{item.dsEmpresa}</td>
                                            {
                                                Object.entries(item).slice(9).map((value) => {
                                                    return <td>{formatMoney(value[1])}</td>
                                                })
                                            }
                                        <td>
                                            {
                                                formatMoney(
                                                    Object.entries(item).slice(9).map((value) => {
                                                        return value[1]
                                                    })
                                                    .reduce((value,next) => {
                                                        return value + next
                                                    })
                                                )
                                            }
                                        </td>
                                        <td>{formatMoney(item.ticketMedio)}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                </Table>
            </Content>

            {
                page !== null &&
                <Button onClick={handleNewData} 
                loadingButton={loadingButton}
                >
                    {
                        loadingButton ?
                            '...aguarde'
                            :
                            'Ver mais'
                    }
                </Button>
            }
        </Container>
    )
}